import UpstartTaxLogo from '@/assets/branding/upstarttax/upstart-tax-academy-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#FF8340',
  brand_primary_hover: '#F56517',
  brand_primary_highlight: '#FFCFB5',
  brand_primary_mid: '#FF9D69',
  brand_primary_dark: '#BD4403',
  brand_secondary: '#E36810',
  brand_accent_start: '#FF944F',
  brand_accent_end: '#F4C542',
  brand_accent_light_start: '#FFF3EA',
  brand_accent_light_end: '#FFF4DA',
  brand_complementary_accent: 'rgb(61,187,255)',
  brand_auth_gradient_mid: '#E36810',
  brand_auth_gradient_end: '#BD4403',
  brand_auth_warp_mid: '#FF9D69',
};

export default {
  name: 'Upstart Tax Academy',
  isSAML: true,
  allowPersonalCourses: false,
  logo: UpstartTaxLogo,
  colors,
};
